export default async function createLocalThumbnail(file: File): Promise<string> {
  return new Promise(function (resolve, reject) {
    try {
      const img = document.createElement('img')
      // When the image is loaded, resize it in canvas.
      img.onload = function () {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        canvas.width = 240
        canvas.height = (canvas.width * img.height) / img.width

        // draw the img into canvas
        ctx?.drawImage(img, 0, 0, canvas.width, canvas.height)
        resolve(canvas.toDataURL())
      }

      img.onerror = reject

      img.src = URL.createObjectURL(file)
    } catch (err) {
      reject(err)
    }
  })
}
